import { Close, Sparkle } from '@audio-network/componentlibrary/icons'

import React from 'react'
import { Text } from '@audio-network/componentlibrary'
import clsx from 'clsx'
import styles from './CurrentRefinements.module.css'
import { useRefinements } from './CurrentRefinements.hooks'
import { useTranslation } from 'next-i18next'

const CurrentRefinements = (): JSX.Element => {
	const { t } = useTranslation(['search'])

	const { refinements, handleClearAll } = useRefinements()

	if (refinements?.length === 0) {
		return null
	}

	return (
		<section className={styles.currentRefinements}>
			<ul className={styles.list}>
				{refinements.length > 0 &&
					refinements.map(({ label, remove, isSearchByPrompt }) => {
						const labelText =
							typeof label === 'string' ? label : label.props.children[1]

						return (
							<li
								className={clsx(
									styles.tag,
									styles.listItem,
									isSearchByPrompt && styles.searchByPrompt
								)}
								key={labelText}
							>
								{isSearchByPrompt && (
									<Sparkle className={styles.aiIcon} color="white" />
								)}
								<Text className={styles.tagText}>{label}</Text>
								<button
									aria-label={`${t('remove')} ${labelText}`}
									type="button"
									onClick={remove}
								>
									<Close className={styles.removeIcon} />
								</button>
							</li>
						)
					})}
				<li>
					<button
						className={clsx(styles.tag, styles.clearAll)}
						onClick={handleClearAll}
					>
						{t('clear-all')}
					</button>
				</li>
			</ul>
		</section>
	)
}

export default CurrentRefinements
